import './offerTextExpander.scss';

interface OfferTextExpander {
  (selector: string, maxLength?: number): void;
  init: (selector: string, maxLength?: number) => void;
}

const offerTextExpander = ((selector: string, maxLength = 300): void => {
  const elements = document.querySelectorAll<HTMLElement>(selector);

  elements.forEach(element => {
    const text = element.textContent || '';

    if (text.length > maxLength) {
      const shortText = text.slice(0, maxLength);
      const remainingText = text.slice(maxLength);

      element.innerHTML = `
        <span>${shortText}</span>
        <span class="offer-text-expander__remaining offer-text-expander__remaining--hidden">${remainingText}</span>
        <button class="offer-text-expander__btn">... ещё</button>
      `;

      const expandBtn = element.querySelector<HTMLButtonElement>('.offer-text-expander__btn');
      const remainingSpan = element.querySelector<HTMLSpanElement>('.offer-text-expander__remaining');

      expandBtn?.addEventListener('click', () => {
        remainingSpan?.classList.remove('offer-text-expander__remaining--hidden');
        expandBtn.classList.add('offer-text-expander__btn--hidden');
      });
    }
  });
}) as OfferTextExpander;

Object.assign(offerTextExpander, {
  init: (selector: string, maxLength = 300): void => {
    offerTextExpander(selector, maxLength);
  },
});

export default offerTextExpander;
